export default __webpack_public_path__ + "static/media/turn-slight-left.0fcbb342.svg";